import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// #region --------------- Material ------------------
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSortModule } from '@angular/material/sort';
import { MatRadioModule } from '@angular/material/radio';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDialogModule } from '@angular/material/dialog';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxGalleryModule } from '@kolkov/ngx-gallery';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { Ng2OrderModule } from 'ng2-order-pipe';
// #endregion --------------- Material ------------------


@NgModule({
  declarations: [],
  imports: [
    MatProgressSpinnerModule,
    MatDialogModule,
    MatListModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSidenavModule,
    MatSortModule,
    MatRadioModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatExpansionModule,
    MatIconModule,
    MatTabsModule,
    MatBadgeModule,
    MatTableModule,
    MatCheckboxModule,
    MatSidenavModule,
    MatListModule,
    MatSlideToggleModule,
    MatInputModule,
    MatButtonModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatStepperModule,
    MatSelectModule,
    // Shared Modules
    NgSelectModule,
    Ng2SearchPipeModule,
    Ng2OrderModule,
  ],
  exports: [
    MatProgressSpinnerModule,
    MatDialogModule,
    MatListModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSidenavModule,
    MatSortModule,
    MatRadioModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatExpansionModule,
    MatIconModule,
    MatTabsModule,
    MatBadgeModule,
    MatTableModule,
    MatCheckboxModule,
    MatSidenavModule,
    MatListModule,
    MatSlideToggleModule,
    MatInputModule,
    MatButtonModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatStepperModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    // Shared Modules
    NgSelectModule,
    Ng2SearchPipeModule,
    Ng2OrderModule,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
  ],
})
export class AngularMaterialModule { }
